import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompaniesService } from '../../../../state/companies.service';
import {
  LocationsRepository,
  LocationsSortOptions,
} from '../../../../state/locations.repository';
import { LocationsService } from '../../../../state/locations.service';
import {
  ICompanyLocation,
  ICompanyMarker,
} from '../../../../state/unauthorized-companies.repository';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
  selector: 'app-admin-locations-page',
  templateUrl: './admin-locations-page.component.html',
  styleUrls: ['./admin-locations-page.component.scss'],
})
export class AdminLocationsPageComponent implements OnInit {
  sortOptions = LocationsSortOptions;
  innerWidth = 0;
  searchFilter: string = '';
  location: ICompanyLocation | null = null;
  client: ICompanyMarker | null = null;
  id: string | null = null;
  deleteConfirmation: ICompanyLocation | null = null;

  constructor(
    public repo: LocationsRepository,
    public service: LocationsService,
    public clientService: CompaniesService,
    private activatedRoute: ActivatedRoute
  ) {}
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }
  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.activatedRoute.paramMap.subscribe({
      next: (value) => {
        this.id = value.get('id');
        if (this.id) {
          this.service
            .reloadPageCustom(this.searchFilter, undefined, this.id)
            .subscribe();
          this.clientService
            .loadOneCompany(this.id)
            .subscribe((x) => (this.client = x));
        }
      },
    });
  }

  refreshData() {
    this.service
      .reloadPageCustom(this.searchFilter, undefined, `${this.id}`)
      .subscribe();
  }

  setFilter(filter?: string) {
    filter ? (this.searchFilter = filter) : (this.searchFilter = '');
    this.service
      .searchRelodePageCustom(this.searchFilter, undefined, `${this.id}`)
      .subscribe();
  }

  handleDeleteClick(post: ICompanyLocation) {
    this.service.delete(post.id).subscribe((x) => {
      this.refreshData();
    });
  }
}
